import { render, staticRenderFns } from "./GoodLogoBtn.vue?vue&type=template&id=4c505e02&lang=pug&"
import script from "./GoodLogoBtn.vue?vue&type=script&lang=js&"
export * from "./GoodLogoBtn.vue?vue&type=script&lang=js&"
import style0 from "./GoodLogoBtn.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports